<svelte:options accessors/>
<script lang="ts">
    import NauiState from "../../naui/atoms/NauiState.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let beneficiario = false;
    export let data = {};

</script>
<section>
    <fieldset>
        <legend>Información de la póliza</legend>
        <table class="simple-table">
            {#if data.poliza.estado}
                <tr>
                    <td style="min-width: 200px;">Estado pago</td>
                    <td>
                        <div class="w-min-content">
                            <NauiState border="true" label="{data.poliza.estado.label}"
                                       code="{data.poliza.estado.code}"/>
                        </div>
                    </td>
                </tr>
            {/if}
            <tr>
                <td>Tomador</td>
                <td>{data.poliza.tomador}</td>
            </tr>
            <tr>
                <td>Tipo de póliza</td>
                <td>{data.poliza.tipo}</td>
            </tr>
            <tr>
                <td>No. Póliza</td>
                <td>{data.poliza.poliza}</td>
            </tr>
            <tr>
                <td>Bien asegurado</td>
                <td>{data.poliza.bienAsegurado}</td>
            </tr>
            <tr>
                <td>Fecha Vencimiento</td>
                <td>{data.poliza.fechaVencimiento}</td>
            </tr>
        </table>
    </fieldset>
    <fieldset>
        <legend>Estado de pago</legend>
        <table class="simple-table">
            <tr>
                <td style="min-width: 200px;">Estado pago</td>
                <td>
                    <div class="w-max-content">
                        <NauiState border="true" label="{data.estado.estadoPago.label}"
                                   code="{data.estado.estadoPago.code}"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>Fecha de pago</td>
                <td>17/05/2021</td>
            </tr>
        </table>
    </fieldset>
    <fieldset>
        <legend>Beneficiarios</legend>
        <table class="naui-table straps max-w-900px w-100 radius overflow-hidden">
            <thead>
            <tr>
                <th>
                    <div>Nombre del beneficiario</div>
                </th>
                <th>
                    <div>Número de documento</div>
                </th>
                <th>
                    <div>Visible para los demás beneficiarios</div>
                </th>
            </tr>
            </thead>
            <tbody>
            {#each data.beneficiarios as ben (ben.documento)}
                <tr>
                    <td>
                        <div class:text-light={!ben.visible}>{ben.nombre}</div>
                    </td>
                    <td>
                        <div class:text-light={!ben.visible}>{ben.documento}</div>
                    </td>
                    <td style="width: 300px">
                        <div class="box">
                            {#if ben.visible}
                                <NauiButton icon="visibility" iconStyle="outlined" color="accent"/>
                            {:else}
                                <NauiButton icon="visibility_off" disabled="{true}" iconStyle="outlined" color="accent"/>
                            {/if}
                        </div>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    </fieldset>
    <fieldset>
        <legend>Coberturas</legend>
        <table class="tabla-cobertura">
            <thead>
            <tr>
                <th class="text-l">{data.coberturaTitle}</th>
                <th style="min-width:150px">Aplica</th>
            </tr>
            </thead>
            <tbody>
            {#each data.coberturas as item}
                <tr>
                    <td>{item.label}</td>
                    <td>
                        <div class="box">
                            {#if item.aplica}
                                <span class="material-icons orange">check_circle</span>
                            {/if}
                        </div>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    </fieldset>

</section>
<style>
    .text-light {
        color: #B6B6B6;
    }

    .tabla-cobertura {
        border-collapse: collapse;

    }

    .tabla-cobertura td {
        padding: .75rem;
        border: 1px solid var(--border-color);
    }

    .tabla-cobertura th{
        background: #6C6F70;
        color: white;
        padding:1rem .75rem;
    }
</style>